module.exports = __webpack_public_path__ + "media/images/front/environment/video-55aae1b0b6ea2dfebff4e3e30861bf91.mp4";